export type Iso2700127701ControlModificacion = {
  id: number;
  fecha: string;
  modificaciones_realizadas: string;
  usuario_modificacion_id: number | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type Iso2700127701ControlModificacionPayload = {
  fecha: string;
  modificaciones_realizadas: string;
};

export function createEmptyControlModificacionForm(): Iso2700127701ControlModificacionPayload {
  return {
    fecha: "",
    modificaciones_realizadas: "",
  };
}
